import React, { Component } from 'react';
import {withRouter} from "react-router";
import {connect} from "react-redux";
import {Area, AreaChart, ResponsiveContainer, XAxis, YAxis, Tooltip, CartesianGrid, Legend} from "recharts";

import VignetItem from "./VignetItem";
import * as overviewReducers from "../../reducers/overview";
import * as overviewActions from "../../actions/overview";
import * as vignetsReducers from "../../reducers/vignets";
import * as vignetsActions from "../../actions/vignets";

class OverviewContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: '',
            userDet : JSON.parse(window.localStorage.userDet),
            graphDuration : 'mon'

        };
        this. setGraphDuration = this.setGraphDuration.bind(this);

    }
    componentDidMount() {

        let data = { type : this.state.graphDuration};
        this.props.graphData(data);
        this.props.shareData();
        let data1 = {user_id: this.state.userDet.user_id, size :'5', type : 'recent_edit' };
        this.props.allRecentData(data1);
        let data2 = {user_id: this.state.userDet.user_id, size :'5', type : 'most_viewed' };
        this.props.allMostviewedData(data2);


    }

    shouldComponentUpdate(nextProps, nextState){
        if(this.props !== nextProps  || this.state !== nextState) {
            return true;
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.vignetsData.recentVignets !== prevProps.vignetsData.recentVignets) {
            for(var i=0; i< this.props.vignetsData.recentVignets.length; i++) {
                if( !this.props.vignetsData.recentVignets[i].vignetProps ) {
                    this.getVigProps(this.props.vignetsData.recentVignets[i].uniqueId , i , 'recent');
                }
            }
        }
        if(this.props.vignetsData.vignetsMostviewed !== prevProps.vignetsData.vignetsMostviewed) {
            console.log(this.props.vignetsData.vignetsMostviewed);
            for(var i=0; i< this.props.vignetsData.vignetsMostviewed.length; i++) {
                if( !this.props.vignetsData.vignetsMostviewed[i].vignetProps ) {
                    this.getVigProps(this.props.vignetsData.vignetsMostviewed[i].uniqueId , i, 'most_viewed');
                }
            }
        }

    }

    setGraphDuration(duration) {
        this.setState({graphDuration : duration});
        let data = { type : duration};
        this.props.graphData(data);
    }

    getVigProps(vigId, itemIndex, section_name){
        let data = { vignet_id : vigId, section : 'overview', index : itemIndex , section_name : section_name };
       // console.log(data)
        this.props.allVignetsProps(data);
       // console.log(this.props.vignetsData.vignetProps);
    }


    render() {

        let recentVignets = this.props.vignetsData ? this.props.vignetsData.recentVignets : undefined;

        let vignetsMostviewed = this.props.vignetsData ? this.props.vignetsData.vignetsMostviewed : undefined;;

        let dashboardGraph =  (this.props.overviewData && this.props.overviewData.dashboardGraph )?this.props.overviewData.dashboardGraph:[];
        console.log(dashboardGraph);

        let shareData =  this.props.overviewData?this.props.overviewData.shareData:[];


        console.log(shareData);
        console.log(recentVignets);


        return (

                    <div className="content-tab">
                        <ul className="nav nav-tabs" id="myTab" role="tablist">
                            <li className="nav-item">
                                <a className="nav-link tab-user-ico active" id="user-tab" data-toggle="tab" href="#user"
                                   role="tab" aria-controls="user" aria-selected="true">Users</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link tab-bw-ico" id="bandwidth-tab" data-toggle="tab"
                                   href="#bandwidth" role="tab" aria-controls="bandwidth"
                                   aria-selected="false">Bandwidth</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link tab-view-ico" id="contact-tab" data-toggle="tab" href="#contact"
                                   role="tab" aria-controls="contact" aria-selected="false">View</a>
                            </li>
                        </ul>
                        <div className="tab-content" id="myTabContent">
                            <div className="fade show active" id="user" role="tabpanel" aria-labelledby="user-tab">
                                <div className="tab__panel">


                                        <div className="graph-headr">
                                            <h5>Statistics of active users - <span className="font-bold">JAN 2019 - DEC 2019</span></h5>
                                            <div className="btn-group" role="group" aria-label="Basic example">
                                                <button type="button" className="btn btn-secondary" onClick={() => this.setGraphDuration('week')}>Week</button>
                                                <button type="button" className="btn btn-secondary active" onClick={() => this.setGraphDuration('mon')}>Month</button>
                                                <button type="button" className="btn btn-secondary" onClick={() => this.setGraphDuration('year')}>Year</button>
                                            </div>
                                        </div>
                                    <div className="graph-plot">
                                        <ResponsiveContainer width="100%" height={380} aspect="width">


                                            <AreaChart  data={dashboardGraph}
                                                        margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                                                <defs>
                                                    <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                                                        <stop offset="5%" stopColor="#dff3fc" stopOpacity={0.8}/>
                                                        <stop offset="95%" stopColor="#dff3fc" stopOpacity={0}/>
                                                    </linearGradient>
                                                    <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
                                                        <stop offset="5%" stopColor="#ecddef" stopOpacity={0.8}/>
                                                        <stop offset="95%" stopColor="#ecddef" stopOpacity={0}/>
                                                    </linearGradient>
                                                    <linearGradient id="colorVv" x1="0" y1="0" x2="0" y2="1">
                                                        <stop offset="5%" stopColor="#ecddef" stopOpacity={0.8}/>
                                                        <stop offset="95%" stopColor="#ecddef" stopOpacity={0}/>
                                                    </linearGradient>
                                                </defs>
                                                <XAxis dataKey="name" />
                                                <YAxis />
                                                <CartesianGrid stroke="#f5f5f5" vertical={false}/>
                                                <Tooltip />
                                                <Legend verticalAlign="top" height={36} iconType={"square"}/>
                                                <Area type="monotone" dataKey="page_views" stroke="#45ace3" fillOpacity={1} fill="url(#colorUv)" />
                                                <Area type="monotone" dataKey="vignet_views" stroke="#eac2e4" fillOpacity={1} fill="url(#colorPv)" />
                                                <Area type="monotone" dataKey="user_views" stroke="#eac234" fillOpacity={1} fill="url(#colorVv)" />
                                            </AreaChart>
                                        </ResponsiveContainer>
                                    </div>
                                    {/*<div className="tab__sub-graph">
                                        <div className="tab__sub-graph--container">
                                            <div className="tab__sub-graph--text">
                                                <div className="tab__sub-graph--left">
                                                    <h4>Main Title</h4>
                                                    <h5>Sub Title</h5>
                                                </div>
                                                <div className="tab__sub-graph--right">
                                                    <h3>78</h3>
                                                </div>
                                            </div>
                                            <div className="tab__sub-graph--section">
                                                <img src="assets/images/chart.png" alt="Small-graph" />
                                            </div>
                                        </div>
                                        <div className="tab__sub-graph--container">
                                            <div className="tab__sub-graph--text">
                                                <div className="tab__sub-graph--left">
                                                    <h4>Main Title</h4>
                                                    <h5>Sub Title</h5>
                                                </div>
                                                <div className="tab__sub-graph--right">
                                                    <h3>112</h3>
                                                </div>
                                            </div>
                                            <div className="tab__sub-graph--section">
                                                <img src="assets/images/chart.png" alt="Small-graph" />
                                            </div>
                                        </div>
                                        <div className="tab__sub-graph--container">
                                            <div className="tab__sub-graph--text">
                                                <div className="tab__sub-graph--left">
                                                    <h4>Main Title</h4>
                                                    <h5>Sub Title</h5>
                                                </div>
                                                <div className="tab__sub-graph--right">
                                                    <h3>354</h3>
                                                </div>
                                            </div>
                                            <div className="tab__sub-graph--section">
                                                <img src="assets/images/chart.png" alt="Small-graph" />
                                            </div>
                                        </div>
                                        <div className="tab__sub-graph--container">
                                            <div className="tab__sub-graph--text">
                                                <div className="tab__sub-graph--left">
                                                    <h4>Main Title</h4>
                                                    <h5>Sub Title</h5>
                                                </div>
                                                <div className="tab__sub-graph--right">
                                                    <h3>253</h3>
                                                </div>
                                            </div>
                                            <div className="tab__sub-graph--section">
                                                <img src="assets/images/chart.png" alt="Small-graph" />
                                            </div>
                                        </div>
                                        <div className="tab__sub-graph--container">
                                            <div className="tab__sub-graph--text">
                                                <div className="tab__sub-graph--left">
                                                    <h4>Main Title</h4>
                                                    <h5>Sub Title</h5>
                                                </div>
                                                <div className="tab__sub-graph--right">
                                                    <h3>22</h3>
                                                </div>
                                            </div>
                                            <div className="tab__sub-graph--section">
                                                <img src="assets/images/chart.png" alt="Small-graph" />
                                            </div>
                                        </div>
                                    </div>*/}
                                </div>


                                <div className="tab__content--social">
                                    <div className="tab__social--items">
                                        <div className="tab__social--img">
                                            <img className="fb-adj" src="assets/images/iconFB.png" alt="Facebook" />
                                        </div>
                                        <div className="tab__social--title-count">
                                            <h4>FACEBOOK</h4>
                                            <h3><span id="tab-social-count">{shareData ? shareData.fb_count : '0'}</span></h3>
                                        </div>
                                    </div>
                                    <div className="tab__social--items">
                                        <div className="tab__social--img">
                                            <img src="assets/images/iconWhatsapp_overview.png" alt="Whatsapp" />
                                        </div>
                                        <div className="tab__social--title-count">
                                            <h4>WHATSAPP</h4>
                                            <h3><span id="tab-social-count">{shareData ? shareData.wa_count : '0'}</span></h3>
                                        </div>
                                    </div>
                                    <div className="tab__social--items">
                                        <div className="tab__social--img">
                                            <img src="assets/images/iconQR_overview.png" alt="googleplus" />
                                        </div>
                                        <div className="tab__social--title-count">
                                            <h4>QR Code</h4>
                                            <h3><span id="tab-social-count">{shareData ? shareData.qr_count : '0'}</span></h3>
                                        </div>
                                    </div>
                                    <div className="tab__social--items">
                                        <div className="tab__social--img">
                                            <img className="oth-adj" src="assets/images/iconOthers.png" alt="other" />
                                        </div>
                                        <div className="tab__social--title-count">
                                            <h4>OTHERS</h4>
                                            <h3><span id="tab-social-count">{shareData ? shareData.other_count : '0'}</span></h3>
                                        </div>
                                    </div>
                                </div>

                                <div className="tab__pannel--container">
                                    <div className="tab__pannel--dsn">
                                        <div className="tab__pannel--header">
                                            <h5>Most Viewed</h5>
                                            <div className="toggle-block">
                                                <button className="icon-lib-list menu-toggle-button"></button>
                                            </div>
                                        </div>
                                        <ul className="tab__pannel-item--list">
                                            { vignetsMostviewed &&

                                            vignetsMostviewed.map((entry, index) => <VignetItem detail={entry} id={index} />)

                                            }
                                        </ul>
                                    </div>

                                    <div className="tab__pannel--dsn">
                                        <div className="tab__pannel--header">
                                            <h5>Recent Edit</h5>
                                            <div className="toggle-block">
                                                <button className="icon-lib-list menu-toggle-button"></button>
                                            </div>
                                        </div>
                                        <ul className="tab__pannel-item--list">

                                            { recentVignets &&

                                            recentVignets.map((entry, index) => <VignetItem detail={entry} id={index} />)

                                            }
                                        </ul>
                                    </div>
                                </div>

                            </div>

                            <div className="tab-panel fade" id="bandwidth" role="tabpanel"
                                 aria-labelledby="bandwidth-tab">

                            </div>



                            <div className="tab-panel fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">

                            </div>


                        </div>
                     </div>


        )
    }

}

function mapStateToProps(state) {
    return {
        overviewData  :overviewReducers.getOverviewData(state),
        vignetsData  : vignetsReducers.getVignetsData(state)
    };

}
export default  withRouter(connect(mapStateToProps, {
    allRecentData : overviewActions.getRecentVignets,
    allMostviewedData : overviewActions.getMostviewedVignets,
    graphData : overviewActions.getGraphData,
    shareData : overviewActions.getShareData,
    allVignetsProps : vignetsActions.getVignetProps
})(OverviewContainer));


// WEBPACK FOOTER //
// ./src/components/overview/OverviewContainer.js